import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DiscIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_144_10692)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 10.5C7.76142 10.5 10 8.26142 10 5.5C10 2.73858 7.76142 0.5 5 0.5C2.23858 0.5 0 2.73858 0 5.5C0 8.26142 2.23858 10.5 5 10.5ZM5 6.5C5.55228 6.5 6 6.05228 6 5.5C6 4.94772 5.55228 4.5 5 4.5C4.44772 4.5 4 4.94772 4 5.5C4 6.05228 4.44772 6.5 5 6.5Z"
          fill={fillColor || '#E0E4E4'}
        />
      </g>
      <defs>
        <clipPath id="clip0_144_10692">
          <rect width="10" height="10" fill={fillColor || 'white'} transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DiscIcon };
